<template>
  <div class="order-submission">
    <div class="allAddress" :style="system_store ? '' : 'padding-top: 0.2rem'">
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type == 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="system_store"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type == 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="system_store"
        ></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.realName">
          <div class="name">
            {{ addressInfo.realName }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.isDefault"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-else
        @click="showStoreList"
      >
        <div class="addressCon">
          <div class="name">
            {{ storeItems.name || system_store.name }}
            <span class="phone">{{
              storeItems.phone || system_store.phone
            }}</span>
          </div>
          <div>
            {{ storeItems.address || system_store.address }}
          </div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <van-form>
        <van-field
          name="saleMan"
          v-model="saleMan"
          label="销售员姓名"
          placeholder="请输入"
          size="large"
        />
        <van-field
          name="saleManPhone"
          v-model="saleManPhone"
          type="tel"
          label="销售员电话"
          placeholder="请输入"
          size="large"
        />
        <van-cell
          title="安装日期"
          :value="installDateText"
          @click="dateShow = true"
          size="large"
        />
        <van-calendar
          v-model="dateShow"
          :show-confirm="false"
          @confirm="dateOnConfirm"
          @cancel="dateOnCancel"
        />
        <van-cell
          title="安装时间"
          :value="installTimeText"
          @click="timeShow = true"
          size="large"
        />
        <van-popup
          v-model="timeShow"
          position="bottom"
          :style="{ height: '79%' }"
        >
          <van-datetime-picker
            v-model="installTime"
            type="time"
            title="选择安装时间"
            :min-hour="9"
            :max-hour="21"
            @confirm="timeOnConfirm"
            @cancel="timeOnCancel"
            square
            clickable
          />
        </van-popup>
        <div class="item acea-row row-between-wrapper">
          <div>现场环境照片</div>
          <div class="discount">
            <div
              class="pictrue"
              v-for="(item, index) in uploadPictures"
              :key="index"
            >
              <img :src="item" />
              <span
                class="iconfont icon-guanbi1 font-color-red"
                @click="uploadPictures.splice(index, 1)"
              ></span>
            </div>
            <VueCoreImageUpload
              class="btn btn-primary"
              :crop="false"
              compress="80"
              @imageuploaded="imageUpload"
              :headers="headers"
              :max-file-size="5242880"
              :credentials="false"
              inputAccept="image/*"
              inputOfFile="file"
              :url="url"
              v-if="uploadPictures.length < 1"
            >
              <div
                class="pictrue uploadBnt acea-row row-center-wrapper row-column"
              >
                <span class="iconfont icon-icon25201"></span>
                <div>拍照上传</div>
              </div>
            </VueCoreImageUpload>
          </div>
        </div>
        <div
          class="item acea-row row-between-wrapper"
          @click="couponTap"
          v-if="deduction === false"
        >
          <div>优惠券</div>
          <div class="discount">
            {{ usableCoupon.couponTitle || "请选择" }}
            <span class="iconfont icon-jiantou"></span>
          </div>
        </div>
        <div
          class="item acea-row row-between-wrapper"
          v-if="deduction === false && enableIntegral === true"
        >
          <div>积分抵扣</div>
          <div class="discount">
            <div class="select-btn">
              <div class="checkbox-wrapper">
                <label class="well-check">
                  <input type="checkbox" v-model="useIntegral" />
                  <i class="icon"></i>
                  <span class="integral">
                    当前积分
                    <span
                      class="num font-color-red"
                      v-if="
                        userInfo.integral > enableIntegralNum &&
                          enableIntegralNum > 0
                      "
                    >
                      {{ userInfo.integral || 0 }},可用{{ enableIntegralNum }}
                    </span>
                    <span class="num font-color-red" v-else>
                      {{ userInfo.integral || 0 }}
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          class="item acea-row row-between-wrapper"
          v-if="shipping_type === 0"
        >
          <div>快递费用</div>
          <div class="discount">
            {{
              orderGroupInfo.priceGroup.storePostage > 0
                ? orderGroupInfo.priceGroup.storePostage
                : "免运费"
            }}
          </div>
        </div>
        <div v-else>
          <div class="item acea-row row-between-wrapper">
            <div>联系人</div>
            <div class="discount">
              <input
                type="text"
                placeholder="请填写您的联系姓名"
                v-model="contacts"
              />
            </div>
          </div>
          <div class="item acea-row row-between-wrapper">
            <div>联系电话</div>
            <div class="discount">
              <input
                type="text"
                placeholder="请填写您的联系电话"
                v-model="contactsTel"
              />
            </div>
          </div>
        </div>
        <van-field name="useFapiao" label="是否开具发票" size="large">
          <template #input>
            <van-radio-group v-model="useFapiao" direction="horizontal">
              <van-radio name="1">否</van-radio>
              <van-radio name="2">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          size="large"
          name="fapiaoMark"
          v-if="useFapiao === '2'"
          v-model="fapiaoMark"
          rows="2"
          autosize
          label="发票备注"
          type="textarea"
          maxlength="150"
          placeholder="发票备注（150字以内）"
          show-word-limit
        />
        <van-field
          size="large"
          name="mark"
          v-model="mark"
          rows="2"
          autosize
          label="订单备注"
          type="textarea"
          maxlength="150"
          placeholder="订单备注（150字以内）"
          show-word-limit
        />
      </van-form>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              余额支付
            </div>
            <div class="tip">可用余额：{{ userInfo.nowMoney || 0 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.totalPrice !== undefined"
      >
        <div>商品总价：</div>
        <div class="money">￥{{ orderPrice.totalPrice }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.payPostage > 0"
      >
        <div>运费：</div>
        <div class="money">￥{{ orderPrice.payPostage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.couponPrice > 0"
      >
        <div>优惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.couponPrice }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deductionPrice > 0"
      >
        <div>积分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deductionPrice }}</div>
      </div>
    </div>
    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合计:
        <span class="font-color-red">￥{{ orderPrice.payPrice }}</span>
      </div>
      <div class="settlement" @click="createOrder">立即结算</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.totalPrice"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<script>
import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed, createOrder } from "@api/order";
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { dataFormatF2, dataFormatT, isWeixin, VUE_APP_API_URL } from "@utils";
import $store from "@/store";
import VueCoreImageUpload from "vue-core-image-upload";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow,
    VueCoreImageUpload
  },
  props: {},
  data: function() {
    return {
      dateShow: false,
      timeShow: false,
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      enableIntegral: true,
      enableIntegralNum: 0,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        payPrice: "计算中"
      },
      fapiaoMark: "",
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      saleMan: "",
      saleManPhone: "",
      installDate: undefined,
      installTime: undefined,
      installDateText: "请选择",
      installTimeText: "请选择",
      installEnvironmentPicture: "",
      store_self_mention: 0,
      useFapiao: "1",
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      url: `${VUE_APP_API_URL}/api/upload`,
      uploadPictures: []
    };
  },
  computed: mapGetters(["userInfo", "storeItems"]),
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) this.getCartInfo();
    },
    shipping_type() {
      this.computedPrice();
    }
  },
  mounted: function() {
    let that = this;
    that.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
  },
  methods: {
    dateOnConfirm(date) {
      this.dateShow = false;
      this.installDate = dataFormatT(date / 1000);
      this.installDateText = dataFormatF2(date / 1000);
    },
    dateOnCancel() {
      this.dateShow = false;
      this.installDate = undefined;
      this.installDateText = "请输入";
    },
    timeOnConfirm(date) {
      this.timeShow = false;
      this.installTime = date;
      this.installTimeText = date;
    },
    timeOnCancel() {
      this.timeShow = false;
      this.installTime = undefined;
      this.installTimeText = "请输入";
    },
    imageUpload(res) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      this.uploadPictures.push(res.link);
    },
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
      console.log("index2:" + this.shipping_type);
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        deptId: $store.state.app.deptId
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.enableIntegral = res.data.enableIntegral;
          this.enableIntegralNum = res.data.enableIntegralNum;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.systemStore || {};
          this.store_self_mention = res.data.storeSelfMention;
          this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      console.log(9999);
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      console.log("coupon:" + coupon);
      if (!coupon) {
        this.usableCoupon = { couponTitle: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },
    createOrder() {
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (!this.addressInfo.id && !this.shipping_type)
        return this.$dialog.toast({ mes: "请选择收货地址" });
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }

      if (
        this.saleMan !== "" &&
        !/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.saleMan)
      ) {
        return this.$dialog.toast({ mes: "请填写销售员真实姓名" });
      }
      if (
        this.saleManPhone !== "" &&
        !/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.saleManPhone)
      ) {
        return this.$dialog.toast({ mes: "请填写销售员正确的手机号" });
      }
      if (
        (this.installDate && !this.installTime) ||
        (this.installTime && !this.installDate)
      ) {
        return this.$dialog.toast({ mes: "请选择安装日期和时间" });
      }
      this.$dialog.loading.open("生成订单中");
      createOrder(this.orderGroupInfo.orderKey, {
        realName: this.contacts,
        phone: this.contactsTel,
        saleMan: this.saleMan,
        saleManPhone: this.saleManPhone,
        installTime:
          this.installDate && this.installTime
            ? new Date(this.installDate + " " + this.installTime).valueOf() /
              1000
            : null,
        installEnvironmentPicture: this.uploadPictures.toString(),
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.active,
        pinkId: this.pinkId,
        seckillId: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        fapiaoMark: this.fapiaoMark || "",
        mark: this.mark || "",
        shippingType: parseInt(shipping_type) + 1,
        storeId: this.storeItems.id || this.system_store.id,
        deptId: $store.state.app.deptId
      })
        .then(res => {
          this.$dialog.loading.close();
          const data = res.data;
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              break;
            case "SUCCESS":
              this.$dialog.success(res.msg);
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              break;
            case "WECHAT_H5_PAY":
              this.$router.replace({
                path: "/order/detail/" + data.result.orderId
              });
              setTimeout(() => {
                location.href = data.result.jsConfig.mweb_url;
              }, 100);
              break;
            case "WECHAT_PAY":
              pay(data.result.jsConfig).finally(() => {
                this.$router.replace({
                  path: "/order/detail/" + data.result.orderId
                });
              });
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "创建订单失败");
        });
    }
  }
};
</script>

<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}

.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}

.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #fea261 0%, #fe7c6e 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #fea261 0%,
    #fe7c6e 100%
  );
  background-image: -moz-linear-gradient(to bottom, #fea261 0%, #fe7c6e 100%);
  padding-top: 1rem;
}

.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .allAddress .nav .item {
  width: 3.55rem;
}

.order-submission .allAddress .nav .item.on {
  position: relative;
}

.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  background-color: #fff;
  bottom: 0;
  content: "工单派送";
  color: #000000;
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0.4rem;
  border-style: solid;
  border-color: #fff;
  z-index: 9;
  text-align: center;
  line-height: 0.14rem;
}

.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0.4rem;
}

.order-submission .allAddress .nav .item.on2 {
  position: relative;
}

.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  background-color: #d5e6e6;
  bottom: 0;
  content: "到店自提";
  color: #000000;
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0.4rem;
  border-style: solid;
  border-color: #d5e6e6;
  text-align: center;
  line-height: 0.14rem;
}

.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "工单派送";
  border-width: 0.4rem;
}

.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}

.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}

.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}

.pictrue.uploadBnt {
  border: 1px dashed #ddd;
}
.pictrue {
  width: 1.4rem;
  height: 1.4rem;
  margin: 0 auto;
  text-align: center;
  position: relative;
  font-size: 0.22rem;
  color: #bbb;
}
.pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.03rem;
}
.pictrue .icon-guanbi1 {
  font-size: 0.45rem;
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
}
.pictrue .icon-icon25201 {
  color: #bfbfbf;
  font-size: 0.5rem;
}
</style>
